module.exports = __webpack_public_path__ + "img/w1.f011649a.png";